"use client";

import { useEffect } from "react";

export default function MetaTags() {
  useEffect(() => {
    // Add Windows-specific meta tags that aren't supported by Next.js metadata API
    const addMetaTag = (name, content, attribute = "name") => {
      if (!document.querySelector(`meta[${attribute}="${name}"]`)) {
        const meta = document.createElement("meta");
        meta.setAttribute(attribute, name);
        meta.setAttribute("content", content);
        document.head.appendChild(meta);
      }
    };

    addMetaTag("msapplication-TileColor", "#ffffff");
    addMetaTag("msapplication-TileImage", "/ms-icon-144x144.png");
  }, []);

  return null;
}
